var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatementsColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0684 1H23.3442C24.2579 1 24.9994 1.74152 24.9994 2.65517V3.48276H15.0684V2.65517C15.0684 1.74152 15.982 1 15.0684 1Z",
    fill: "#07278A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1377 13.8276V2.65517C5.1377 1.74152 5.87921 1 6.79287 1H23.3446C22.4309 1 21.6894 1.74152 21.6894 2.65517V23.3448C21.6894 24.2585 20.9479 25 20.0342 25H5.1377V23.7586V13.8276Z",
    fill: "#F2FAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0345 25H2.65517C1.74152 25 1 24.2585 1 23.3448V22.5172H18.3793V23.3448C18.3793 24.2585 19.1208 25 20.0345 25Z",
    fill: "#2C479C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79287 10.5181C6.2177 10.5181 5.66238 10.605 5.1377 10.7614V15.4828V21.861C5.66238 22.0174 6.2177 22.1043 6.79287 22.1043C9.99149 22.1043 12.586 19.5098 12.586 16.3112C12.586 13.1125 9.99149 10.5181 6.79287 10.5181Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37931 20.8629C9.35022 20.8629 11.7586 18.4545 11.7586 15.4836C11.7586 12.5126 9.35022 10.1042 6.37931 10.1042C3.4084 10.1042 1 12.5126 1 15.4836C1 18.4545 3.4084 20.8629 6.37931 20.8629Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2089 10.931C4.23869 10.931 1.82959 13.3401 1.82959 16.3112C1.82959 17.5857 2.27566 18.755 3.01635 19.677C3.93828 20.4185 5.10766 20.8637 6.38131 20.8637C9.35152 20.8637 11.7606 18.4546 11.7606 15.4836C11.7606 14.2091 11.3146 13.0397 10.5739 12.1178C9.65193 11.3763 8.48255 10.931 7.2089 10.931Z",
    fill: "#FCB701"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0345 25H2.65517C1.74152 25 1 24.2585 1 23.3448V22.5172H18.3793V23.3448C18.3793 24.2585 19.1208 25 20.0345 25Z",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1377 8.44828V2.65517C5.1377 1.74152 5.87921 1 6.79287 1H23.3446C22.4309 1 21.6894 1.74152 21.6894 2.65517V23.3448C21.6894 24.2585 20.9479 25 20.0342 25",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0688 1H23.3447C24.2584 1 24.9999 1.74152 24.9999 2.65517V3.48276",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72412 17.5517C4.80853 17.6643 5.46564 18.3793 6.37929 18.3793C7.29295 18.3793 8.03447 17.6833 8.03447 16.7241C8.03447 15.6094 6.77571 15.1947 6.37929 15.0689C5.98288 14.9431 5.13791 14.5128 5.13791 13.8276C5.13791 13.1423 5.69405 12.5862 6.37929 12.5862C6.82371 12.5862 7.36991 12.8163 7.62067 13.0058",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37939 19.2069V18.3793",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37939 12.5863V11.7587",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51421 10.9293C4.34428 10.4063 5.32662 10.1034 6.37931 10.1034C9.34952 10.1034 11.7586 12.5125 11.7586 15.4835C11.7586 18.4546 9.34952 20.8637 6.37931 20.8637C3.4091 20.8637 1 18.4546 1 15.4835C1 14.4317 1.30207 13.4493 1.8251 12.6201",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1893 13.4138H13.4136",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 11.7587H15.8965",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1893 10.1034H14.2412",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2242 11.7587H12.5864",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5689 10.1034H10.9312",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 5.13794H15.8965",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7412 5.13794H7.62061",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2238 5.13794H13.4136",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.086 6.79309H7.62061",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3963 8.44824H7.62061",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1894 8.44824H15.0688",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 6.79309H16.7241",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0518 6.79309H11.7588",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementsColor);
export default __webpack_public_path__ + "static/media/statements-color.f0a45a337110d784d1c957f830ac06b2.svg";
export { ForwardRef as ReactComponent };